import script from "./PopupCelebration.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupCelebration.vue?vue&type=script&setup=true&lang=js"

import "./PopupCelebration.vue?vue&type=style&index=0&id=77ff2168&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77ff2168"]])

export default __exports__